// 3_pages/search_luigi.js
// Luigi's Box search page: collapses/moves filters, fixes the cart icon, cleans up
// body/html classes after a search, and wires the autocomplete close button to the
// mobile search toggle via mutation observers.

export function init() {
	document.addEventListener("luigiSearchDone", function () {
		if (document.querySelector("#lb-search-element")) {
			addCollapsedToAllFilters();
			moveFilters();
			fixKosikInVyhledavani();
		}
		removeActiveFromMobileSearchButton();
		removeClassesFromBody();

		function addCollapsedToAllFilters() {
			const filters = document.querySelectorAll(".lb-facet");
			filters.forEach(function (filter) {
				filter.classList.add("custom-collapsed");
				filter.addEventListener("click", function () {
					filter.classList.remove("custom-collapsed");
				});
			});
		}

		function moveFilters() {
			const filtersContainer = document.querySelector(".lb-search__aside");
			const targetContainer = document.querySelector(".lb-quick-searches");

			if (filtersContainer && targetContainer) {
				//move filters after target container
				targetContainer.parentNode.insertBefore(filtersContainer, targetContainer.nextSibling);
			}
		}

		function removeActiveFromMobileSearchButton() {
			const headerSearch = document.querySelector("#header .search");
			if (!headerSearch) return;
			headerSearch.classList.remove("active-mobile-search");
		}

		function removeClassesFromBody() {
			document.body.classList.remove("ordering-process");
		}

		document.querySelector("html").classList.remove("lb-lock-scroll");
		document.body.classList.add("in-luigi-vyhledavani");
	});

	document.addEventListener("DOMContentLoaded", function () {
		const luigiAcElement = document.querySelector(".luigi-ac");
		if (luigiAcElement) {
			addMutationObserverToLuigi(luigiAcElement);
		} else {
			// wait for luigi-ac to be added
			const observer = new MutationObserver((mutations, obs) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1 && node.classList.contains("luigi-ac")) {
							addMutationObserverToLuigi(node);
							obs.disconnect(); // stop observing
						}
					});
				});
			});
			observer.observe(document.body, {
				childList: true,
				subtree: true,
			});
		}

		function addMutationObserverToLuigi(luigiAcElement) {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1) {
							// Only element nodes
							if (node.classList.contains("luigi-ac-close")) {
								attachCloseHandler(node);
							}
							// Also check for any descendants with the class
							node.querySelectorAll?.(".luigi-ac-close").forEach(attachCloseHandler);
						}
					});
				});
			});

			function attachCloseHandler(luigiAcClose) {
				luigiAcClose.addEventListener("click", function () {
					const mobileSearchButton = document.querySelector(".mobile-search-button");
					if (mobileSearchButton) {
						mobileSearchButton.click();
					}
				});
			}

			observer.observe(luigiAcElement, {
				childList: true,
				subtree: true,
			});
		}
	});
}

function fixKosikInVyhledavani() {
	const navigationButtons = document.querySelector("#header .navigation-buttons");
	if (!navigationButtons) {
		return;
	}
	if (!navigationButtons.querySelector("a")) {
		console.log("Navigation buttons are empty, fixing cart icon in search.");
		const cartLink = document.createElement("a");
		cartLink.href = window.NAT.translations("kosikUrl");
		cartLink.className = "btn btn-icon toggle-window cart-count full hovered";
		cartLink.dataset.target = "cart";
		cartLink.dataset.hover = "true";
		cartLink.dataset.redirect = "true";
		cartLink.dataset.testid = "headerCart";
		cartLink.rel = "nofollow";
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.setAttribute("aria-expanded", "false");
		cartLink.setAttribute("aria-controls", "cart-widget");

		navigationButtons.appendChild(cartLink);
		navigationButtons.style.setProperty("display", "flex", "important");
	}
}
